import RecordAction from './RecordAction';

class ExtensionAction extends RecordAction {
  constructor(selectedRecords, action) {
    super(selectedRecords);
    this.command = action.contribution;
    this.extension = action.extension;
    this.recordTypes = this.command.recordTypes;
  }

  get title() {
    return this.command.name;
  }

  showForRecord(record) {
    // Disable extension actions for Roadmaps screens unless feature flag
    // is enabled
    return (
      (window.currentProject?.isTeam ||
        window.featureFlags.extension_views_in_roadmaps) &&
      super.showForRecord(record)
    );
  }
}

export default ExtensionAction;
